import { PAYMENT_BASE_URL_V2 } from "../../../constants";

/**
 * PAYMENT_BASE_URL_V2 is `…/payment-actions/v2/payments/`; cashout banks are exposed by the same
 * service one segment over, at `…/payment-actions/v2/cashout-banks`.
 */
export const CASHOUT_BANKS_URL = `${PAYMENT_BASE_URL_V2}`.replace(
  /payments\/?$/,
  "cashout-banks"
);
